import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import { StreakCell } from "../StreakCell";
import { StreakCountChip } from "../StreakCountChip";

type DailyStreakData = {
	day: string;
	type: "completed" | "missed" | "unattempted";
	isToday?: boolean;
};

type DailyStreakChartProps = {
	weekData: DailyStreakData[];
	currentStreak: number;
	bestStreak: number;
};

export const DailyStreakChart = ({
	weekData,
	currentStreak,
	bestStreak,
}: DailyStreakChartProps) => {
	const theme = useAppTheme();

	return (
		<Box
			gap={8}
			alignItems="center"
			paddingHorizontal={16}
			style={{ width: "100%" }}
		>
			<Box
				flexDirection="row"
				gap={12}
				justifyContent="center"
				style={{ width: "100%" }}
			>
				<StreakCountChip
					type="current"
					count={currentStreak}
					icon={
						<MaterialCommunityIcons
							name="fire"
							size={24}
							color={theme.colors.onSecondaryContainer}
						/>
					}
				/>
				<StreakCountChip
					type="best"
					count={bestStreak}
					icon={
						<MaterialCommunityIcons
							name="star-outline"
							size={24}
							color={theme.colors.onSecondaryContainer}
						/>
					}
				/>
			</Box>

			<Box
				flexDirection="row"
				justifyContent="space-between"
				style={{ width: "100%", maxWidth: 456, paddingTop: 16 }}
			>
				{weekData.map((dayData) => (
					<StreakCell
						key={dayData.day}
						day={dayData.day}
						status={dayData.type}
						isToday={!!dayData.isToday}
					/>
				))}
			</Box>
		</Box>
	);
};
